
export default {
  name: `AdminLogin`,
  components: {
  },
  data () {
    return {
      password: '',
      successMsg: null,
      errorMsg: null,
      loading: false
    }
  },
  computed: {
    isDisabled () {
      if (!this.email || !this.password) {
        return true;
      }
      return false;
    },
    email: {
      get () {
        return this.$store.state.email;
      },
      set (val) {
        this.$store.dispatch('setEmail', val);
      }
    }
  },
  methods: {
    login () {
      this.loading = true;
      this.errorMsg = null;
      this.successMsg = null;

      this.$http.post('/auth/login_with_password', {email: this.email, password: this.password})
      .then((response) => {
        if (!response.data.error && response.data.is_admin) {
          this.errorMsg = null;
          this.successMsg = 'Logged In';

          const afterLoginPath = window.sessionStorage.getItem('afterLoginPath');
          window.sessionStorage.removeItem('afterLoginPath');

          window.setTimeout(() => window.location.href = afterLoginPath || window.appConfig.adminUrl || '/ho/admin', 10);
        }
        else {
          this.errorMsg = response.data.error;
        }
      })
      .catch((error) => {
        console.log(error);
        this.errorMsg = error.toString();
      })
      .finally(() => {
        this.loading = false;
      });
    }
  },
  mounted () {
    console.log('adminlogin');
  },
  template: `
    <div class="admin-login-component">
      <div class="innblocks-logo logo32 theme"></div>
      <h3>Log In</h3>
      <form class="form" v-on:submit.prevent="login">
        <div class="row">
          <label class="label">
              <span class="label-text">Email Address</span>
              <span class="input-wrap">
                  <input type="email" v-model="email" />
              </span>
          </label>
        </div>
        <div class="row">
          <label class="label">
              <span class="label-text">Password</span>
              <span class="input-wrap">
                  <input type="password" v-model="password" />
              </span>
          </label>
        </div>
        <div class="success" v-if="successMsg">
            {{successMsg}}
        </div>
        <div class="error" v-if="errorMsg">
            {{errorMsg}}
        </div>
        <div class="row">
          <button type="submit" :disabled="isDisabled" class="button">
            <span v-if="loading">...</span>
            <span v-if="!loading">Login</span>
          </button>
        </div>
        <div class="row small">
          <router-link :to='{name: "forgotPassword"}'>Forgot password?</router-link>
        </div>
        <div class="row small">
        Not a member? <router-link :to='{name: "signup"}'>Sign Up Now!</router-link>
        </div>
      </form>
    </div>
  `,
};